import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3a2d49de&scoped=true&lang=pug&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=3a2d49de&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=3a2d49de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2d49de",
  null
  
)

export default component.exports